<template>
  <div
    :style="`padding-top:10px;color:white;width:${dispW - 2}px;height:${
      dispH - 20
    }px;border:1px solid gray`"
  >
    <el-row>
      <el-col :span="5">
        <el-radio v-model="option" :label="options.ecc" name="median-mode">ecc</el-radio>
      </el-col>
      <el-col :span="4">
        <el-radio v-model="option" :label="options.E" name="median-mode">E-val</el-radio>
      </el-col>
      <el-col :span="5">
        <el-radio v-model="option" :label="options.P" name="median-mode">P-val</el-radio>
      </el-col>
      <el-col :span="5">
        <el-radio v-model="option" :label="options.Q" name="median-mode">Q-val</el-radio>
      </el-col>
      <el-col :span="5">
        <el-radio v-model="option" :label="options.SAGCURV" name="median-mode"
          >Sagittal Curvature</el-radio
        >
      </el-col>
    </el-row>
    <div style="width: 100%; height: 5px"></div>
    <el-row>
      <el-table
        :header-cell-style="headerRowStyle"
        :cell-style="cellStyle"
        :data="medianData"
        style="width: 100%"
        :row-style="manufRowStyle"
        :header-row-style="headerRowStyle"
        :highlight-current-row="false"
        row-key="keyid"
      >
        <el-table-column prop="title" label="Dia \ Dir"></el-table-column>
        <el-table-column prop="nas" label="Nas">
          <template slot-scope="scopeNas">
            <span :style="`color:${scopeNas.row.nascolor}`">
              {{ scopeNas.row.nas | paramNormal }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="temp" label="Temp">
          <template slot-scope="scopeTemp">
            <span :style="`color:${scopeTemp.row.tempcolor}`">
              {{ scopeTemp.row.temp | paramNormal }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="inf" label="Inf">
          <template slot-scope="scopeInf">
            <span :style="`color:${scopeInf.row.infcolor}`">
              {{ scopeInf.row.inf | paramNormal }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="sup" label="Sup">
          <template slot-scope="scopeSup">
            <span :style="`color:${scopeSup.row.supcolor}`">
              {{ scopeSup.row.sup | paramNormal }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="flat" label="Flat">
          <template slot-scope="{ row }">
            <span :style="`color:lightgreen`">
              {{ row.flat }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="steep" label="Steep">
          <template slot-scope="{ row }">
            <span :style="`color:red`">
              {{ row.steep }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="mean" label="Mean">
          <template slot-scope="scopeMean">
            <span :style="`color:${scopeMean.row.meancolor}`">
              {{ scopeMean.row.mean | paramNormal }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
  </div>
</template>
<script>
import DataParams from "../dataGetters/params";
import { MAJMEDIANMODES } from "../shared/index";
import { paramNormal } from "../../shared/filters";
const rowstyle = "color: white;font-size: 20px; text-align: center;border: none;";
const headstyle =
  "background-color:#2D3039;color:white;font-size:20px;text-align:center;border:none;border-bottom:1px solid gray";
const cellstyle = "text-align:center;vertical-align:middle;border:none;font-size:22px";
let dataParams = new DataParams();
export default {
  name: "MeridianFigure",
  data() {
    return {
      options: MAJMEDIANMODES,
      option: MAJMEDIANMODES.ecc,
      medianData: []
    };
  },
  // 0.Q 1.P - VAL  2.E 3.ecc 4.SAGCURV
  mounted() {
    this.getData();
  },
  watch: {
    option: function () {
      this.getData();
    }
  },
  props: {
    dispW: {
      type: Number,
      default: window.screen.width - 30 - 500
    },
    dispH: {
      type: Number,
      default: window.screen.height - 80 - 10
    },
    mapValues: {
      type: Object
    }
  },
  methods: {
    getData() {
      if (this.option < this.options.SAGCURV) {
        let { frontpValOfMajMeridians, isShowGrayF } = this.mapValues;

        this.medianData =
          dataParams.getMajMedianWithoutGray(
            frontpValOfMajMeridians,
            isShowGrayF,
            this.mapValues.params["AxisFlat"].value,
            this.option
          ) || [];
      } else {
        this.medianData = this.mapValues.sagCurMedian || [];
      }
    },
    filterHandle(v) {
      return paramNormal(v);
    },
    headerRowStyle() {
      return headstyle;
    },
    lenRowStyle({ row, rowIndex }) {
      return `background-color:#2D3039;${rowstyle}`;
    },
    manufRowStyle({ row, rowIndex }) {
      return `background-color:#2D3039;${rowstyle}`;
    },
    cellStyle() {
      return cellstyle;
    }
  }
};
</script>
<style scoped>
.el-radio {
  margin: 0px;
  text-align: left;
  font-size: 25px;
}
.el-radio /deep/ .el-radio__label {
  color: white;
  font-size: 25px;
}
.el-radio /deep/ .el-radio__inner {
  width: 23px;
  height: 23px;
  padding: 0px;
  margin: 0px;
}

.el-radio /deep/ .el-radio__inner::after {
  width: 5px;
  height: 5px;
}
.el-radio /deep/ .el-radio__input {
  vertical-align: middle;
}
.div-table {
  border: 1px solid gray;
}
.el-table {
  font-size: 18px;
}
.el-table::before {
  height: 0px;
}
.el-table /deep/ td {
  padding: 4px;
  background-color: rgb(45, 48, 57);
}
.el-table th,
.el-table tr {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/topography/components/MeridianFigure.vue